import { useCallback, useMemo } from 'react';
import { format, fromUnixTime, parse } from 'date-fns';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBCultureSelectedEmergencyDateCP,
  setEmergencyDateCP,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';
import useOptions from './useOptions';

export default function useEmergency() {
  const { options } = useOptions();
  const dateIntervals = useMemo(() => {
    if (!options) return [];

    return [{
      start: fromUnixTime(options.startDate),
      end: fromUnixTime(options.endDate),
    }];
  }, [options]);
  const emergencyValue = useSelector(selectMeteorologyAgroWBCultureSelectedEmergencyDateCP);
  const emergencyDate = useMemo(() => {
    if (!emergencyValue) return null;
    return parse(emergencyValue, 'yyyy-MM-dd', new Date());
  }, [emergencyValue]);

  const changeEmergencyDate = useCallback((newDate: Date | null) => {
    const newEmergencyDate = newDate ? format(newDate, 'yyyy-MM-dd') : undefined;
    store.dispatch(setEmergencyDateCP(newEmergencyDate));
  }, []);

  return {
    dateIntervals,
    emergencyDate,
    changeEmergencyDate,
  };
}
